<div>
  <label [for]="id" class="block text-sm font-medium text-gray-700">{{ label }}</label>
  <input
    [type]="type"
    [id]="id"
    [ngModel]="value"
    (blur)="onTouched()"
    (ngModelChange)="onValueChange($event)"
    [disabled]="disabled"
    [class]="
      hasErrors ? 
        'focus:border-red-500 focus:outline focus:outline-red-500' : 
        'focus:border-blue-500 focus:outline focus:outline-blue-500'
    "
    class="mt-1 block w-full rounded-md border bg-white border-gray-300 shadow-sm p-2 disabled:opacity-50 disabled:cursor-not-allowed"
    [placeholder]="placeholder || ''" 
    autocomplete="off"
    [attr.data-1p-ignore]="!canShow1passSuggestion()"/>
  @if (hasErrors) {
    <app-control-errors [control]="control" />
  }
</div>